function App() {
    var app = this,
        allImages = {},
        header = $('.crossrope-header'),
        main = $('#PageContainer'),
        offset,headerHeight;
    app.inView = false;
    app.isMobile = false;
    app.isDesktop = false;

    this.init = function () {
        app.product();
        app.videos(true);
        if($('#ProductJson-product-template').length > 0) {
            app.current_product = JSON.parse(
                document.getElementById('ProductJson-product-template').innerHTML
            );
        }
        $('.page-container').on('contextmenu', 'video, img', function(e){
            //alert("Images are copyright protected and may not be used without express written consent.");
            return false;
        });

        app.sliders();
        app.quotes();
        app.upsells();
        app.shogun();
        app.measurements();
        $(document).ready(function () {
            headerHeight = header.outerHeight();
            app.stick();
            app.popups();
            app.dropdown();
            app.navigation();
            app.geolocate();
            app.tracking();
            app.apparel();
            app.crosssells();
            app.fixedPrices();
            app.resize();
            // app.memberships();
            app.productMetafields();
            app.videoSlider();
            app.adjustYotpoReviews();
            // app.optinMonsterCampaign();
            app.tooltips();

            // app.updatePlpSaleBadges();
            // setTimeout(() => {
            //     app.updatePlpSaleBadges();
            // }, 1500);

            app.initAnchorLinks();
        });
        $(window).scroll(function () {
            app.stick();
            app.workoutVideos();
            app.counter();
            app.dragme();
        });
        $(window).resize(function () {
            app.videos(false);
            app.resize();
        });
        $('#CartDrawer').on('cartUpdate', function () {
            app.tooltips();
        })
        function setFormHeight() {
            const element = document.querySelector('.product-single__meta');
            if (element && !element.classList.contains('form-sticky')) {
                const wrapper = document.querySelector('.product-details-wrapper');
                wrapper.style.height = 'auto';
                wrapper.style.height = `${wrapper.offsetHeight}px`;
            }
        }
        
        setFormHeight();

        let collapses = document.querySelectorAll('.pdp-collapse__content');

        collapses.forEach((collapse) => {
           collapse.addEventListener("transitionend", (event) => {
            setFormHeight();
           });
        })

        let recipientToggle = document.querySelector("#Recipient-checkbox-product-template");
        if (recipientToggle) {            
            recipientToggle.addEventListener('change', () => {
                setFormHeight();
            })
        }
        
        window.addEventListener('resize',(event) => {
            setFormHeight();
        });
        window.addEventListener('orientationchange',(event) => {
            setFormHeight();
        });
        window.addEventListener('scroll',(event) => {
            const element = document.querySelector('.product-single__meta');
            if (!recipientToggle) {
                const productInfoEl = document.querySelector('.grid.product-single');
                if (productInfoEl) {
                    const { top, left, bottom, right } = productInfoEl.getBoundingClientRect();
                    $(element).toggleClass('form-sticky', bottom < 0);
                }
            }
        });
    };

    this.resize = function () {
        var crosssellsWrapper = $('[data-cart-crosssells]'),
            cartLineItems = $('[data-cart-line-items]'),
            cartSection = $('#shopify-section-cart-template');
        if(cartSection.length == 1) {
            if($(window).width() > 767) {
                if(crosssellsWrapper.hasClass('moved')) {
                    crosssellsWrapper.insertAfter(cartLineItems);
                    crosssellsWrapper.removeClass('moved');
                }
            } else {
                if(!crosssellsWrapper.hasClass('moved')) {
                    crosssellsWrapper.appendTo(cartSection);
                    crosssellsWrapper.addClass('moved');
                }
            }
        }
        if ($(window).width() < 768) {
            app.isMobile = true;
            app.isDesktop = false;
        } else {
            app.isMobile = false;
            app.isDesktop = true;
        }
    };

    this.track = function (name) {
        console.log(name);
        // Is Gtag loaded
        if(typeof(gtag) == 'function'){
            // Track Google Custom Event
            gtag('event', name,{'event_category' : name,'event_label' : name});
        }
    };

    this.tracking = function () {
        $('[data-ga-track]').on('click',function(){
            let name = $(this).data('ga-name');
            app.track(name);
        });
        $('.reviews-placeholder').on('click','.yotpo-bottomline',function (e) {
            app.track('NAVReviewsLink');
        });
    };

    this.initAnchorLinks = function() {
        if(location.hash.includes('#') && location.hash.length > 1) {
            setTimeout(() => {
                $('html, body').animate({scrollTop: $(location.hash).offset().top - 70}, 700)
            }, 2000)
        }
    };

    this.videos = function (onload) {
        var videoEl = $('#hero-video'),
            video,parent,desktopUrl,mobileUrl,desktopPoster,mobilePoster,onload,source;

        if(videoEl.length > 0) {
            video = videoEl[0];
            parent = videoEl.closest('.video-container');
            desktopUrl = parent.data('desktop-video');
            mobileUrl = parent.data('mobile-video') || desktopUrl;
            desktopPoster = parent.data('desktop-poster');
            mobilePoster = parent.data('mobile-poster') || desktopPoster;
            onload = (typeof onload === 'undefined') ? false : onload;

            if(onload) {
                source = document.createElement("source");
                source.setAttribute("type", "video/mp4");
                video.appendChild(source);
            } else {
                source = $('#hero-video source')[0];
            }
            video.onloadeddata = (event) => {
                parent.removeAttr('style');
            };
            if ($(window).width() < 768) {
                if(!app.isMobile) {
                    //parent.css({'background-image':'url('+mobilePoster+')'});
                    video.pause();
                    source.src = mobileUrl;
                    source.setAttribute('preload', 'auto');
                    video.load();
                    video.play();
                    app.isMobile = true;
                    app.isDesktop = false;
                }
            } else {
                if(!app.isDesktop) {
                    //parent.css({'background-image':'url('+desktopPoster+')'});
                    video.pause();
                    source.src = desktopUrl;
                    source.setAttribute('preload', 'auto');
                    video.load();
                    video.play();
                    app.isMobile = false;
                    app.isDesktop = true;
                }
            }
        }
    };

    this.workoutVideos = function () {
        var workoutContainerVideos = $('.workout-container video');
        if(workoutContainerVideos.length > 0) {
            workoutContainerVideos.each(function (index,workoutContainerVideo) {
                if ($(workoutContainerVideo).is(":in-viewport")) {
                    //if(!app.inView) {
                        $(workoutContainerVideo)[0].play();
                        //$(this)[1].play();
                        app.inView = true;
                    //}
                } else {
                    app.inView = false;
                    $(workoutContainerVideo)[0].pause();
                    $(workoutContainerVideo)[0].currentTime = 0;
                    //$(this)[1].pause();
                    //$(this)[1].currentTime = 0;
                }
            });
        }
    };

    this.navigation = function () {
        $('.site-header').on('click', '.reviews-placeholder', function(e) {
            e.preventDefault();
            window.location.href = '/pages/reviews';
            return;
        });
        $('a.btn-scroll').on('click', function(e) {
            var id = '#'+this.getAttribute('href').split("#").pop(),
                target = $(id);
            if(target.length > 0) {
                $('.crossrope-header').removeClass('dropdown-open');
                $('.site-header__menu').addClass('mobile-nav--open');
                $('.site-header__menu').removeClass('mobile-nav--close');
            }
        });
    };

    this.geolocate = function () {
        var bodyClass = null,
            usdTooltip = '',
            // Exlude GB from EU countries temporarily
            // eu_redirected_countries = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","GB"],
            eu_redirected_countries = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"],
            country = theme.GeoLocation.country();
            console.log('theme.GeoLocation.country:', country)
        if(country == 'CA') {
            $('[data-ca-redirect]').each(function (index,el) {
                $(this).prop('href',$(this).data('ca-redirect'));
            });
            $('[data-ca-price]').each(function (index,el) {
                $(this).text($(this).data('ca-price'));
            });
            $('[data-availability]').each(function (index,el) {
                app.availability(el,'availability');
            });
            $('[data-ca-availability]').each(function (index,el) {
                app.availability(el,'ca-availability');
            });
            bodyClass = 'country-ca';
        }
        if(eu_redirected_countries.indexOf(country) > -1) {
            $('[data-eu-redirect]').each(function (index,el) {
                $(this).prop('href',$(this).data('eu-redirect'));
            });
            $('[data-eu-price]').each(function (index,el) {
                $(this).text($(this).data('eu-price'));
            });
            $('[data-availability]').each(function (index,el) {
                app.availability(el,'availability');
            });
            $('[data-eu-availability]').each(function (index,el) {
                app.availability(el,'eu-availability');
            });
            bodyClass = 'country-eu';
        }
        if(country == 'US') {
            $('.affirm-promo-short, .affirm-promo').addClass('show');
            $('[data-availability]').each(function (index,el) {
                app.availability(el,'availability');
            });
            bodyClass = 'country-us';
        } else {
            usdTooltip = '<span class="usd-tooltip">USD<span>All payments processed in USD.</span></span>';
            // $('[data-cart-popup-subtotal]').append(usdTooltip);
            // $('[data-cart-subtotal]').append(usdTooltip);
            // $('[data-cart-fake-subtotal]').append(usdTooltip);
        }
        if(bodyClass) {
            $('body').addClass(bodyClass);
        }
    };

    this.availability = function (el,label) {
        var availabilityClass = 'product-badge-not-available',
            allClasses = ['product-badge-not-available','product-badge-limited','product-badge-available'],
            card = $(el).closest('.product-card');
        switch($(el).data(label)) {
            case 1:
                availabilityClass = 'product-badge-limited';
                break;
            case 2:
                availabilityClass = 'product-badge-available';
                break;
        }
        $.each(allClasses,function (index,className) {
            card.removeClass(className);
        });
        card.addClass(availabilityClass);
    };

    this.shogun = function () {

    };

    // this.optinMonsterCampaign = function() {
    //     if(location.href.includes('/blogs')) {
    //         window.addEventListener('scroll',(event) => {
    //             if(document.querySelector('[data-optin-monster-css]')) document.querySelector('[data-optin-monster-css]').remove();
    //         });
    //     }
    // };

    // this.updatePlpSaleBadges = function() {
    //     const customBadges = document.querySelectorAll('.custom-badge');
    //     if (customBadges.length > 0) {
    //         setTimeout(() => {
    //             customBadges.forEach((badge) => {
    //                 if (badge.innerHTML.toLowerCase().includes('save')) {
    //                     const parent = badge.closest('.grid__item');
    //                     if (parent.querySelector('.price__sale')) {
    //                         if(parent.querySelector('.price__sale .price-item--regular').getAttribute('ge-data-converted-price')) {
    //                             const comparePrice = parseFloat(parent.querySelector('.price__sale .price-item--regular').getAttribute('ge-data-converted-price'));
    //                             const salePrice = parseFloat(parent.querySelector('.price__sale .price-item--sale').getAttribute('ge-data-converted-price'));
    //                             const currency = parent.querySelector('.price__sale .price-item--sale').getAttribute('ge-data-converted-full-price').replace(parent.querySelector('.price__sale .price-item--sale').getAttribute('ge-data-converted-price'), '')[0];
    //                             badge.innerHTML = `Save ${currency}${(comparePrice - salePrice).toFixed(2)}`;
    //                             badge.setAttribute("saving-price-re-calculated", "true")
    //                         }
    //                     }
    //                 }
    //             })
    //         }, 1200);
    //     }
    // };

    this.adjustYotpoReviews = function() {
        const bottomLines = document.querySelectorAll('.yotpo.bottomLine[data-count]');
        setTimeout(() => {
            bottomLines.forEach((bottomLine) => {
                const counts = parseInt(bottomLine.dataset.count);
                const average = bottomLine.dataset.average;
                const ariaLabel = `${average} (${counts} ${counts > 1 ? 'Reviews' : 'Review'})`;
                const element = bottomLine.querySelector('.yotpo-bottomline a');
                if(element) {
                    element.innerHTML = ariaLabel;
                    element.setAttribute('aria-label', ariaLabel);
                }
                if(bottomLine.querySelector('.yotpo-stars')) {
                    const newStyle = `<style>[data-yotpo-element-id="${bottomLine.dataset.yotpoElementId}"] .yotpo-stars::before{width: calc( 100% / 5 * ( 5 - ${average} ) )}</style>`;
                    bottomLine.innerHTML = newStyle + bottomLine.innerHTML;
                }
            });
            const siteWidget = document.querySelector('.site-header__icons-wrapper .yotpo.bottomLine');
            if(siteWidget && siteWidget.innerHTML.trim() == '') {
                const options = {
                    method: 'GET',
                    headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
                    };
                if(typeof yotpo != 'undefined' && yotpo) {
                    fetch(`https://api.yotpo.com/products/${yotpo.appKey}/yotpo_site_reviews/bottomline`, options)
                        .then(response => response.json())
                        .then(data => {
                            console.log(data);
                            siteWidget.innerHTML = `<a href="/pages/reviews" style="display:inline-flex;align-items:center"><span class="yotpo-stars yotpo-site-custom" style="margin-right:5px;"></span> ${data.response.bottomline.average_score} (${data.response.bottomline.total_reviews} Reviews)</a>`;
                            siteWidget.innerHTML += `<style>.yotpo-site-custom::before{width: calc( 100% / 5 * ( 5 - ${data.response.bottomline.average_score} ) )}</style>`;
                        })
                        .catch(err => console.error(err));
                }
            }

            const mainWidget = document.querySelector('.yotpo-main-widget');
            if(mainWidget && mainWidget.innerHTML.trim() != '' && mainWidget.querySelector('.yotpo-stars')) {
                const average = mainWidget.dataset.average;
                const newStyle = `<style>[data-yotpo-element-id="${mainWidget.dataset.yotpoElementId}"] .yotpo-stars::before{width: calc( 100% / 5 * ( 5 - ${average} ) )}</style>`;
                mainWidget.innerHTML = newStyle + mainWidget.innerHTML;
            }
        }, 2000);
    };

    this.dropdown = function () {
        var header = $('.crossrope-header'),
            mobileLink = $('.site-header__menu'),
            links = $('[data-products-dropdown-link]');
        links.each(function(){
            $(this).hover(
                function() {header.addClass('dropdown-open ' + $(this).data('products-dropdown-link'))},
                function() {
                    if(!$('.products-dropdown' + '.'+$(this).data('products-dropdown-link')).is(':hover')) {
                        header.removeClass('dropdown-open ' + $(this).data('products-dropdown-link'));
                    }
                },
            );
            $('.products-dropdown').on('mouseleave',function (e) {
                header.removeClass('dropdown-open').removeClass($(this).data('products-dropdown-link'));
            });
            $(this).on('touchstart', function(e) {
                e.preventDefault();
                header.toggleClass('dropdown-open ' + $(this).data('products-dropdown-link'));
            });
        })
        mobileLink.on('click',function (e) {
            $(this).toggleClass('mobile-nav--open');
            $(this).toggleClass('mobile-nav--close');
            header.toggleClass('dropdown-open');
            header.removeClass('products')
            if (header.hasClass('dropdown-open')) {
                header.addClass('products')
            }
            app.track('NAVMobileOpenClick');
        });
    };

    this.popups = function () {
        var vimeoPopup = $('.popup-vimeo'),
            imagePopups = $('.image-popup-link'),
            sizeChartPopups = $('[data-size-chart]'),
            apparelSizeChartPopups = $('[data-apparel-size-chart]'),
            appPopups = $('[data-app-modal-link]'),
            relatedPopups = $('[data-related-modal-link]'),
            pdpModal = $('[href="#pdp_modal"]'),
            announcementModal = $('[href="#announcement_modal"]');
            videoCarouselPopus = $('.carousel-video-popup');

        if(vimeoPopup.length > 0) {
            vimeoPopup.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                iframe: {
                    patterns: {
                        vimeo: {
                            index: 'vimeo.com/',
                            id: '/',
                            src: '//player.vimeo.com/video/%id%?color=71CC98'
                        }
                    }
                },
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').removeClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(videoCarouselPopus.length > 0) {
            videoCarouselPopus.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">'+
                            '<div class="mfp-close"></div>'+
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                        '</div>',
                    // patterns: {
                    //     shopify: {
                    //         index: 
                    //     }
                    // }
                    srcAction: 'iframe_src'
                }
            });
        }
        if(imagePopups.length > 0) {
            imagePopups.magnificPopup({
                type: 'image',
                mainClass: 'mfp-img-mobile',
                image: {
                    verticalFit: true
                },
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').removeClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(pdpModal.length > 0) {
            pdpModal.magnificPopup({
                items: {
                    src: '#pdp_modal',
                    type: 'inline'
                }
                ,
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').addClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(appPopups.length > 0) {
            appPopups.magnificPopup({
                items: {
                    src: '#app-modal',
                    type: 'inline'
                },
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').removeClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(relatedPopups.length > 0) {
            relatedPopups.magnificPopup({
                type: 'inline',
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').removeClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(sizeChartPopups.length > 0) {
            sizeChartPopups.magnificPopup({
                items: {
                    src: '#size-modal',
                    type: 'inline'
                },
                callbacks: {
                    beforeOpen: function () {
                        $('.size-guide-modal').removeClass('shipping-guide-modal');
                    }
                }
            });
        }
        if(apparelSizeChartPopups.length > 0) {
            $.each(apparelSizeChartPopups,function (index,el) {
                var sizeChart = $(this).data('apparel-size-chart') || 'women';
                apparelSizeChartPopups.magnificPopup({
                    items: {
                        src: '#apparel-size-modal-'+sizeChart.toLowerCase(),
                        type: 'inline'
                    },
                    callbacks: {
                        beforeOpen: function () {
                            $('.size-guide-modal').removeClass('shipping-guide-modal');
                        }
                    }
                });
            });

        }
        if (announcementModal.length > 0) {
            const triggers = document.querySelectorAll('[href="#announcement_modal"]');
            const pageDetails = document.querySelector('.announcement-modal [data-page-details]');
            if (triggers.length > 0) {
                triggers.forEach((modal_trigger) => {
                    modal_trigger.addEventListener('click', (event) => {
                        if (event.target.closest('[data-page]')) {
                            const pageUrl = event.target.closest('[data-page]').dataset.page;
                            fetch(pageUrl)
                                .then(response => response.text())
                                .then((responseText) => {
                                    const innerHTML = new DOMParser().parseFromString(responseText, 'text/html').getElementById('MainContent').innerHTML;
                                    pageDetails.innerHTML = innerHTML;
                                });
                        }
                    });
                })
            }
            announcementModal.magnificPopup({
                items: {
                    src: '#announcement_modal',
                    type: 'inline'
                }
            });
        }
    };
    this.tooltips = function() {
        var membershipTooltip = $('[href="#membership_modal"]')

        if (membershipTooltip.length) {
            $(membershipTooltip).each((index, tooltip) => {
                const pageUrl = $(tooltip).closest('[data-page]').data('page');
                console.log('url',$(tooltip).closest('[data-page]'))
    
                $(tooltip).tooltipster({
                    content: 'Loading...',
                    contentAsHTML: true,
                    theme: 'tooltipster-light',
                    updateAnimation: false,
                    position: 'left',
                    maxWidth: 300,
                    interactive: true,
                    trigger: 'click',
                    functionInit: function(instance, helper) {
                        if ($(helper.origin).data('ajax') !== 'cached') {
                            fetch(pageUrl)
                            .then(response => response.text())
                            .then((responseText) => {
                                const innerHTML = new DOMParser().parseFromString(responseText, 'text/html').getElementById('MainContent').innerHTML;
                                $(helper.origin).tooltipster('content', innerHTML).data('ajax', 'cached');
                            });
                        }
    
                        return
                    }
                })
    
                $(tooltip).on('mouseover', () => {
                    $(tooltip).tooltipster('open');
                })
    
                $(tooltip).on('mouseleave', () => {
                    $(tooltip).tooltipster('close');
                })
            })
        }
    }
    this.quotes = function () {
        var quotesContainer = $('.press-quotes-container'),
            tabs,
            links;

        if(quotesContainer.length > 0) {
            links = quotesContainer.find('ul li a');
            tabs = quotesContainer.find('.press-quotes-wrapper .item');
            links.on('click',function (e) {
                e.preventDefault();
                var id = $(this).attr('href').replace('#press-quote-','');
                id = parseInt(id) - 1;
                links.removeClass('active');
                $(this).addClass('active');
                tabs.removeClass('active');
                $(tabs.get(id)).addClass('active');
            });
        }
    };

    this.product = function () {
        var container = $('[data-section-type="product"]'),
            productTabs,
            productFaqs,
            featuredProductImages;
        if(container.length > 0) {
            featuredProductImages = $('.featured-product-images');
            allImages = featuredProductImages.find('img[data-alt]');

            featuredProductImages.on('init', function(slick){
                setTimeout(function () {
                    $(".product-gallery").addClass("product-gallery--slick-was-initialized")
                }, 500);
            });

            if(!featuredProductImages.hasClass('slick-initialized')) {
                featuredProductImages.slick({
                    dots: true,
                    arrows: true,
                    slidesToShow: 1,
                    rows: 0,
                    adaptiveHeight: true,
                    appendDots: '#thumbnails-wrapper',
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            customPaging: function (slider, i) {
                                var videoClass = $(slider.$slides[i]).find("[data-thumb]").data("video") ? ' video':'';
                                return '<a class="desktop'+ videoClass +'" href="javascript:void(0);"><img src="'+$(slider.$slides[i]).find("[data-thumb]").data("thumb")+'" width="56" height="56" /></a>';
                            }
                        }
                    }]
                    
                });

            }

            productTabs = $('.product-tabs');
            if(productTabs.length > 0) {
                productTabs.on('click','ul li a',function (e) {
                    e.preventDefault();
                    var id = $(this).attr('href');
                    productTabs.find('ul li').removeClass('active');
                    productTabs.find('.tab-contents > div').removeClass('active');
                    $(this).closest('li').addClass('active');
                    productTabs.find(id).addClass('active');
                });
            }
        }
            productFaqs = $('.product-faqs');
            if(productFaqs.length > 0) {
                productFaqs.on('click','dl dt',function (e) {
                    e.preventDefault();
                    $(this).toggleClass('open');
                });
            }
    };

    this.upsells = function () {
        var upsellWrapper = $('.upsell-wrapper');
        if(upsellWrapper.length > 0) {
            var checkbox = upsellWrapper.find('[name="upsell[app]"]'),
                parentContainer = upsellWrapper.find('.membership-checkbox-group'),
                radios = upsellWrapper.find('[name="upsell[app-option]"]'),
                additional = upsellWrapper.find('[name="upsell[product]"]');
            // checkbox.on('change',function (e) {
            //     if(!$(this).is(':checked')) {
            //         radios.prop('checked', false);
            //         parentContainer.removeClass('show-options');
            //     } else {
            //         parentContainer.addClass('show-options');
            //         if(upsellWrapper.find('[name="upsell[app-option]"]:checked').length == 0) {
            //             radios.first().prop('checked',true);
            //             radios.first().trigger('change');
            //         }
            //     }
            //     $('.single-option-selector-product-template').trigger('change');
            // });
            // radios.on('change',function (e) {
            //     if(upsellWrapper.find('[name="upsell[app-option]"]:checked').length > 0) {
            //         checkbox.prop('checked',true);
            //         checkbox.trigger('change');
            //     }
            //     $('.single-option-selector-product-template').trigger('change');
            // });
            additional.on('change',function (e) {
                $('[class*="single-option-selector-product-template"]').trigger('change');
                const firstSelectedUpsell = document.querySelector('[name="upsell[product]"]:checked');
                const addToCartButton = document.querySelector('button[data-add-to-cart].addon-required');
                if(addToCartButton) {
                    if(firstSelectedUpsell && firstSelectedUpsell.value) {
                        addToCartButton.removeAttribute('disabled');
                    } else {
                        addToCartButton.setAttribute('disabled','disabled');
                    }
                }

            });
        }
    };

    this.apparel = function () {
        var selectSizeBtn = $('.select-size-btn'),
            toggleMetric = $('[data-toggle-sizes]'),
            productSwatches = $('.selector-wrapper-apparel');
        if(productSwatches.length > 0) {
            $('.selector-wrapper-apparel:last-child select').trigger('changeOnLoad');
            selectSizeBtn.on('click',function (e) {
                e.preventDefault();
                productSwatches.addClass('error');
            });
            productSwatches.on('click','.swatch',function (e) {
                e.preventDefault();
                var value = $(this).data('value'),
                    type = $(this).data('option-type'),
                    parent = $(this).closest('.selector-wrapper-apparel'),
                    select = parent.find('select');
                parent.removeClass('error');
                parent.find('.swatch').removeClass('selected');
                $(this).addClass('selected');
                select.val(value);
                select.trigger('change');
                if(type == 'swatch') {
                    parent.find('> label > span').text(value);
                }
            });
        }
        if(toggleMetric.length > 0) {
            toggleMetric.on('click',function (e) {
                e.preventDefault();
                var type = $(this).data('toggle-sizes'),
                    parent = $(this).closest('.crossrope-popup'),
                    links = parent.find('[data-toggle-sizes]'),
                    els = parent.find('[data-metric]');
                links.removeClass('active');
                $(this).addClass('active');
                $.each(els,function (index,el) {
                    $(el).text($(el).data(type));
                });
            })
        }
    };
  
    this.memberships = function () {
          var options = $('input[name="membership[]"]'),
              membershipsWrapper = $('.memberships-wrapper'),
              heading = membershipsWrapper.find('.membership-title span'),
              selectSizeBtn = $('.select-size-btn');

          if(options.length > 0) {
              $.each(options,function (index,el) {
                  if(index > 0) {
                      return false;
                  }
              });
              options.on('change',function (e) {
                  var option = $('input[name="membership[]"]:checked');
                  if(option) {
                      membershipsWrapper.removeClass('error');
                      var optionId = option.val(),
                          optionTitle = option.data('option-label'),
                          optionInterval = option.data('interval');
                      heading.text(optionTitle);
                      $('input[name="id"]').val(optionId);
                      $('input[name="properties[shipping_interval_frequency]"]').val(optionInterval);
                      selectSizeBtn.removeClass('active');
                  }
              });
              selectSizeBtn.on('click',function (e) {
                  e.preventDefault();
                  membershipsWrapper.addClass('error');
              });
          }
      };

    this.updateSwatch = function (color) {
        var gallery = $('.featured-product-images'),
            slide,slideIndex;
        if(gallery.hasClass('slick-initialized')) {
            slide = gallery.find('.item:not(.slick-cloned)[data-alt="'+color+'"]');
            if(slide) {
                slideIndex = slide.data('slick-index');
                if(slideIndex) {
                    gallery.slick('slickGoTo',slideIndex);
                }
            }
        }
    };

    this.measurements = function () {
        var selectSizeBtn = $('.select-size-btn'),
            productMeasurements = $('.select-measurements'),
            productMeasurementsSelect = $('.single-option-selector-size'),
            toggleMetric = $('[data-show-metric]'),
            metrics = ['height','length','inventory'],
            labels = ['height','length','inventory'],
            sizes = {'data-size-label-tablet':'code','data-size-label-desktop':'size'};
        if(productMeasurements.length > 0) {
            selectSizeBtn.on('click',function (e) {
                e.preventDefault();
                productMeasurements.addClass('error');
                if(!document.querySelector('.product-single__meta').classList.contains('form-sticky')) {
                    $('html, body').animate({
                        scrollTop: productMeasurements.offset().top - 120
                    }, 50);
                }
            });

            productMeasurements.find('.measurements-container > div[data-code]').each(function (index,el) {
                var parentEl = $(this);
                $.each(labels,function (index,label) {
                    console.log(label);
                    console.log(parentEl.data(label));
                    parentEl.find('[data-'+label+'-label]').text(parentEl.data(label));
                });
                $.each(sizes,function (index,label) {
                    parentEl.find('['+index+']').text(parentEl.data(label));
                });
            });
            productMeasurements.on('click','.label a',function (e) {
                e.preventDefault();
                productMeasurements.removeClass('error');
                productMeasurements.toggleClass('open');
            });
            productMeasurements.on('click','div[data-code] a',function (e) {
                e.preventDefault();
                var parentEl = $(this).closest('div'),
                    code = parentEl.data('code'),
                    imageId = parentEl.data('image-id');
                productMeasurements.removeClass('error');
                productMeasurements.find('div[data-code]').removeClass('selected-option');
                productMeasurementsSelect.val(code);
                productMeasurements.removeClass('open');
                productMeasurements.addClass('selected');
                parentEl.addClass('selected-option');
                productMeasurementsSelect.trigger('change');
                selectSizeBtn.removeClass('active');
                if (typeof imageId != 'undefined' && imageId && imageId != '') {
                    const slickIndex = $(`.featured-product-images .item[data-image-id="${imageId}"]`).data('slick-index');
                    $('.featured-product-images').slick('slickGoTo', slickIndex);
                }
                const upsellInputs = document.querySelectorAll('[name="upsell[product]"]');
                upsellInputs.forEach((input) => {
                    const customSwitch = input.closest('.custom-switch');
                    const productData = JSON.parse(customSwitch.querySelector('[type="application/json"]').innerHTML);
                    let firstVariant = productData.variants.filter((v) => v.option1 === code && v.available)[0];
                    if(typeof firstVariant == 'undefined' || !firstVariant) firstVariant = productData.variants.filter((v) => v.available)[0];
                    if(typeof firstVariant == 'undefined' || !firstVariant) firstVariant = productData.variants[0];
                    input.value = firstVariant.id;
                })
            });
            productMeasurements.on('update_metric',function (e,metric) {
                $(this).find('.measurements-container > div[data-code]').each(function (index,el) {
                    var parentEl = $(this);
                    $.each(metrics,function (index,label) {
                        var dataLabel = label;
                        if(metric) {
                            dataLabel = 'metric_'+label;
                        }
                        parentEl.find('[data-'+label+'-label]').text(parentEl.data(dataLabel));
                    });
                });
            });
            toggleMetric.on('click',function (e) {
                e.preventDefault();
                productMeasurements.removeClass('error');
                if(!productMeasurements.hasClass('selected')) {
                    productMeasurements.addClass('open');
                    $('html, body').animate({
                        scrollTop: productMeasurements.offset().top - 120
                    }, 500);
                }
                if($(this).data('show-metric') === true) {
                    $(this).data('show-metric',false);
                    $(this).text('show metric');
                    productMeasurements.trigger('update_metric',[false]);
                } else {
                    $(this).data('show-metric',true);
                    $(this).text('show standard');
                    productMeasurements.trigger('update_metric',[true]);
                }
            });
        }
    };

    this.sliders = function () {
        var resultsSlider = $('.results-slider'),
            reviewsSlider = $('.reviews-carousel'),
            mediaSlider = $('.media-slider'),
            mobileHero = $('.mobile-hero-slideshow');
            videoCarousel = $('.carousel-videos');

        if(reviewsSlider.length > 0) {
            reviewsSlider.slick({
                infinite: true,
                dots: false,
                arrows: true,
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 0,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                ]
            });
        }

        if(mobileHero.length > 0) {
            mobileHero.slick({
                infinite: true,
                dots: false,
                arrows: false,
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
            });
        }

        if(resultsSlider.length > 0) {
            resultsSlider.slick({
                centerMode: true,
                centerPadding: '200px',
                infinite: true,
                dots: false,
                arrows: true,
                swipeToSlide: true,
                lazyLoad: 'ondemand',
                slidesToShow: 5,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 4,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '50px',
                        }
                    }
                ]
            });
        }

        if(mediaSlider.length > 0) {
            mediaSlider.slick({
                infinite: true,
                dots: false,
                arrows: true,
                swipeToSlide: true,
                centerMode: true,
                lazyLoad: 'progressive',
                slidesToShow: 6,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 475,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        if (videoCarousel.length > 0) {
            videoCarousel.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3
            });
        }
    };

    this.stick = function () {
        if($(window).scrollTop() >= headerHeight){
            header.addClass('stuck');
        } else {
            header.removeClass('stuck');
        }
    };

    this.crosssells = function () {
        var localCrosssells = this.getData('crossrope_crosssells') || [],
            newlocalCrosssells = [];
        if(typeof crosssellProducts !== 'undefined') {
            $.each(crosssellProducts,function (i,crosssellProduct) {
                newlocalCrosssells.push(crosssellProduct.id);
            });
            $.each(localCrosssells,function (j,localCrosssell) {
                if(_.indexOf(newlocalCrosssells,localCrosssell.id) == -1) {
                    crosssellProducts.push(localCrosssell);
                }
            });

            this.setData('crossrope_crosssells',crosssellProducts);
        }
    };

    this.fixedPrices = function () {

        var globalFP = this.getData('crossrope_fp') || [],
            globalCAFP = this.getData('crossrope_cafp') || [],
            globalPC = this.getData('crossrope_pc') || {};

            var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

        if(typeof crossropeFixedPrices !== 'undefined') {
                // let localFP = {
                //     ...globalFP,
                //     ...crossropeFixedPrices
                // };
                // use _extends instead of spread syntax above for iOS Safari compatibility
                let localFP = _extends({}, globalFP, crossropeFixedPrices);
            this.setData('crossrope_fp',localFP);
        }


        if(typeof crossropeCaFixedPrices !== 'undefined') {
                // let localCAFP = {
                //     ...globalCAFP,
                //     ...crossropeCaFixedPrices
                // };
                // use _extends instead of spread syntax above for iOS Safari compatibility
                let localCAFP = _extends({}, globalCAFP, crossropeCaFixedPrices);
            this.setData('crossrope_cafp',localCAFP);
        }
        if(typeof crossropePcPrices !== 'undefined') {
            let localPC = {
                ...globalPC,
                ...crossropePcPrices
            };
            this.setData('crossrope_pc',localPC);
        }
        // setTimeout(() => {
        //     const gePrices = document.querySelectorAll('[ge-data-converted-price]');
        //     gePrices.forEach((gePrice) => {
        //         gePrice.innerHTML = gePrice.innerHTML.replace(/.00/g, '')
        //     });
        // }, 1500);
        // setTimeout(() => {
        //     const gePrices = document.querySelectorAll('[ge-data-converted-price]');
        //     gePrices.forEach((gePrice) => {
        //         gePrice.innerHTML = gePrice.innerHTML.replace(/.00/g, '')
        //     });
        // }, 3000);
    };

    this.productMetafields = function () {
        var globalNoFreeShippingIds = this.getData('crossrope_no_free_shipping') || [];
        if(typeof window.localNoFreeShipping !== 'undefined') {
            $.each(window.localNoFreeShipping,function (j,localId) {
                if(_.indexOf(globalNoFreeShippingIds,localId) === -1) {
                    globalNoFreeShippingIds.push(localId);
                }
            });

            this.setData('crossrope_no_free_shipping',globalNoFreeShippingIds);
        }
    };

    this.videoSlider = function () {
        var slider = $('.video-slider'),
            handle = slider.length > 0 ? slider.find('.handle') : [],
            handleContainer = slider.length > 0 ? slider.find('.handle-container') : [],
            sliderContainer = slider.length > 0 ? slider.find('[data-slider-container]') : [],
            offset = 64,
            width = 0,
            realWidth = 0;
        if(slider.length > 0 && handle.length > 0) {
            offset = Number(slider.find('.handle').width());
            width = Number(slider.data('video-width'));
            realWidth = handleContainer.width();
            handleContainer.css({'max-width':(width + offset)+'px'});
            if(app.isMobile) {
                handle.css({'left': 'calc(50% - 16px)'});
            }
            $('.handle').draggable({
                axis: "x",
                containment: "parent",
                drag: function(event, ui) {
                    realWidth = slider.find('.handle-container').width() - offset;
                    var position = Math.round((ui.position.left * 100)/realWidth);
                    handle.addClass('handle-moved');
                    if(position <= 10) {
                        handle.addClass('handle-left');
                    } else if(position >= 90) {
                        handle.addClass('handle-right');
                    } else {
                        handle.removeClass('handle-right');
                        handle.removeClass('handle-left');
                    }

                    sliderContainer.width(position + '%');
                }
            });
        }
    };

    this.dragme = function () {
        var slider = $('.video-slider'),
            handle = slider.length > 0 ? slider.find('.handle') : [],
            handleAnimation = null;
        if(slider.length > 0 && handle.length > 0) {
            if(handle.is(":in-viewport")) {
                setTimeout(function () {
                    handle.addClass('shake-horizontal');
                }, 2000);
            } else {
                handle.removeClass('shake-horizontal');
            }
        }
    };

    this.counter = function () {
        var counters = $('[data-counter]'),
            bar = $('.calories-bar'),
            barAfter =  bar.find('.after'),
            barAnimation = null,
            maxDuration = 0;
        if(counters.length > 0) {
            if(bar.is(":in-viewport")) {
                if(!bar.hasClass('counted')) {
                    bar.addClass('counted');
                    var barWidth = 100;
                    barAnimation = setInterval(function () {
                            if (barWidth <= 0) {
                            clearInterval(barAnimation);
                            barWidth = 0 + '%';
                        } else {
                            barWidth--;
                        }
                        barAfter.width(barWidth + '%');
                    }, 40);
                }
            } else {
                clearInterval(barAnimation);
                bar.removeClass('counted');
                barAfter.width('100%');
            }
            counters.each(function() {
                var $this = $(this),
                    countTo = parseInt($this.attr('data-calories').replace(/,/g, '')),
                    duration = (Math.floor(countTo / 100) * 100)/250
                    maxDuration = maxDuration > duration ? maxDuration : duration;

                if ($this.is(":in-viewport")) {
                    if(!$this.hasClass('counted')) {
                        $this.addClass('counted');
                        const c = new CountUp(this, 0, countTo, 0, duration, {
                            useEasing: false,
                            useGrouping: true
                        });
                        c.start();
                    }
                } else {
                    if($this.hasClass('counted')) {
                        $this.removeClass('counted');
                    }
                }
            });
        }
    };

    this.getData = function(key) {
        return JSON.parse(localStorage.getItem(key));
    };

    this.setData = function(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    };

    this.removeData = function (key) {
        localStorage.removeItem(key);
    };

    this.decodeHTML = function (html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };
}

var crossropeApp = new App();
crossropeApp.init();
